import {action} from 'typesafe-actions';
import {Toast, ToastActionTypes} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const addToast = (toast: Toast) =>
  action(ToastActionTypes.ADD_TOAST, toast);

export const removeToast = (toast: Toast) =>
  action(ToastActionTypes.REMOVE_TOAST, toast);
